import { HomePage } from "pages/Home/Home";
import { Navigate } from "react-router";

import { Maintenance } from "pages/Maintenance/Maintenance";
import { Tasks } from "pages/Tasks/Tasks";
import { Routes, Route } from "react-router";
import { PlanPage } from "pages/Plan/PlanPage";
import {
  DASHBOARD,
  MAINTENANCE,
  PLAN,
  TASKS,
} from "constants/api/routeGlobals";
import { Dashboard } from "pages/DashBoard/Dashboard";

export const routes = (
  <Routes>
    <Route element={<HomePage />}>
      <Route index element={<Navigate to={PLAN} replace />} />
      <Route path={PLAN} element={<PlanPage />} />
      <Route path={DASHBOARD} element={<Dashboard />} />
      <Route path={MAINTENANCE} element={<Maintenance />} />
      <Route path={TASKS} element={<Tasks />} />
    </Route>
  </Routes>
);
